import { createVNode as _createVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-00b6afd6")

_pushScopeId("data-v-00b6afd6")
const _hoisted_1 = { class: "card border-left-danger shadow mx-0 mb-4 animated fadeIn" }
const _hoisted_2 = { class: "card-header py-3 d-flex flex-row align-items-center justify-content-start" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "fas fa-arrow-circle-left" }, null, -1)
const _hoisted_4 = { class: "m-0 font-weight-bold" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Order ")
const _hoisted_6 = { style: {"font-style":"italic"} }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" details ")
const _hoisted_8 = {
  key: 0,
  class: "card-body p-3"
}
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-lg-6 col-md-6 col-sm-12 col-12" }
const _hoisted_11 = /*#__PURE__*/_createVNode("h4", { style: {"background-color":"#f8f9fa","padding":"12px"} }, "Order", -1)
const _hoisted_12 = { class: "table text-left details-table mt-0" }
const _hoisted_13 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Order ID", -1)
const _hoisted_14 = { class: "table-list-value" }
const _hoisted_15 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Order UUID", -1)
const _hoisted_16 = {
  class: "table-list-value font-weight-light text-monospace",
  style: {"font-size":"0.9rem"}
}
const _hoisted_17 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Side", -1)
const _hoisted_18 = { class: "table-list-value" }
const _hoisted_19 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Automatic Execution", -1)
const _hoisted_20 = {
  key: 0,
  class: "table-list-value"
}
const _hoisted_21 = /*#__PURE__*/_createVNode("span", { class: "badge badge-primary" }, "TRUE", -1)
const _hoisted_22 = {
  key: 1,
  class: "table-list-value"
}
const _hoisted_23 = /*#__PURE__*/_createVNode("span", { class: "badge badge-pill badge-secondary" }, "FALSE", -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Status", -1)
const _hoisted_25 = {
  key: 0,
  class: "table-list-value"
}
const _hoisted_26 = /*#__PURE__*/_createVNode("span", { class: "badge badge-pill badge-success" }, "Filled", -1)
const _hoisted_27 = {
  key: 1,
  class: "table-list-value"
}
const _hoisted_28 = /*#__PURE__*/_createVNode("span", { class: "badge badge-pill badge-warning" }, "Partially filled", -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "btn btn-sm btn-success ml-2",
  style: {"font-size":"12px","padding":"1px 6px"}
}, [
  /*#__PURE__*/_createTextVNode(" Create filling order "),
  /*#__PURE__*/_createVNode("i", { class: "fas fa-exchange-alt" })
], -1)
const _hoisted_30 = {
  key: 2,
  class: "table-list-value"
}
const _hoisted_31 = /*#__PURE__*/_createVNode("span", { class: "badge badge-pill badge-danger" }, "Pending", -1)
const _hoisted_32 = /*#__PURE__*/_createVNode("button", {
  type: "button",
  class: "btn btn-sm btn-success ml-2",
  style: {"font-size":"12px","padding":"1px 6px"}
}, [
  /*#__PURE__*/_createTextVNode(" Create filling order "),
  /*#__PURE__*/_createVNode("i", { class: "fas fa-exchange-alt" })
], -1)
const _hoisted_33 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Created At", -1)
const _hoisted_34 = { class: "table-list-value" }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Last Modified At", -1)
const _hoisted_37 = { class: "table-list-value" }
const _hoisted_38 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Amount", -1)
const _hoisted_39 = { class: "table-list-value" }
const _hoisted_40 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_41 = { style: {"font-size":"18px"} }
const _hoisted_42 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Unit Price", -1)
const _hoisted_43 = { class: "table-list-value" }
const _hoisted_44 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_45 = { style: {"font-size":"18px"} }
const _hoisted_46 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Final Price", -1)
const _hoisted_47 = { class: "table-list-value" }
const _hoisted_48 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_49 = { style: {"font-size":"18px"} }
const _hoisted_50 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Total Cost", -1)
const _hoisted_51 = { class: "table-list-value" }
const _hoisted_52 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_53 = { style: {"font-size":"18px"} }
const _hoisted_54 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Base Currency Revenue", -1)
const _hoisted_55 = {
  class: "table-list-value",
  style: {"font-weight":"600"}
}
const _hoisted_56 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_57 = { style: {"font-size":"18px"} }
const _hoisted_58 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Quote Currency Revenue", -1)
const _hoisted_59 = {
  class: "table-list-value",
  style: {"font-weight":"600"}
}
const _hoisted_60 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_61 = { style: {"font-size":"18px"} }
const _hoisted_62 = /*#__PURE__*/_createVNode("tr", null, [
  /*#__PURE__*/_createVNode("td"),
  /*#__PURE__*/_createVNode("td")
], -1)
const _hoisted_63 = { class: "col-lg-6 col-md-6 col-sm-12 col-12" }
const _hoisted_64 = /*#__PURE__*/_createVNode("h4", { style: {"background-color":"#f8f9fa","padding":"12px"} }, "Customer", -1)
const _hoisted_65 = { class: "table text-left details-table" }
const _hoisted_66 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Id", -1)
const _hoisted_67 = { class: "table-list-value" }
const _hoisted_68 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Email", -1)
const _hoisted_69 = { class: "table-list-value" }
const _hoisted_70 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Full Name", -1)
const _hoisted_71 = { class: "table-list-value" }
const _hoisted_72 = /*#__PURE__*/_createVNode("h4", { style: {"background-color":"#f8f9fa","padding":"12px"} }, "Pair", -1)
const _hoisted_73 = { class: "table text-left details-table" }
const _hoisted_74 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Base Currency", -1)
const _hoisted_75 = { class: "table-list-value" }
const _hoisted_76 = /*#__PURE__*/_createVNode("td", { class: "table-list-header" }, "Quote Currency", -1)
const _hoisted_77 = { class: "table-list-value" }
const _hoisted_78 = { class: "row" }
const _hoisted_79 = { class: "col-12" }
const _hoisted_80 = /*#__PURE__*/_createVNode("h4", { style: {"background-color":"#f8f9fa","padding":"12px","margin-bottom":"0","border-bottom":"1px solid #e9ecef"} }, " Filling orders ", -1)
const _hoisted_81 = /*#__PURE__*/_createTextVNode(" No filling orders. ")
const _hoisted_82 = {
  key: 0,
  class: "badge badge-success"
}
const _hoisted_83 = {
  key: 1,
  class: "badge badge-danger"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_router_link = _resolveComponent("router-link")
  const _component_icons_currency = _resolveComponent("icons-currency")
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("a", {
        href: "#",
        class: "text-dark mr-2",
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$router.back()), ["prevent"]))
      }, [
        _hoisted_3
      ]),
      _createVNode("h6", _hoisted_4, [
        _hoisted_5,
        _createVNode("span", _hoisted_6, "#" + _toDisplayString(_ctx.$route.params.id), 1),
        _hoisted_7
      ])
    ]),
    (_ctx.selectedOrder)
      ? (_openBlock(), _createBlock("div", _hoisted_8, [
          _createVNode("div", _hoisted_9, [
            _createVNode("div", _hoisted_10, [
              _hoisted_11,
              _createVNode("table", _hoisted_12, [
                _createVNode("tr", null, [
                  _hoisted_13,
                  _createVNode("td", _hoisted_14, "#" + _toDisplayString(_ctx.selectedOrder.id), 1)
                ]),
                _createVNode("tr", null, [
                  _hoisted_15,
                  _createVNode("td", _hoisted_16, _toDisplayString(_ctx.selectedOrder.uuid), 1)
                ]),
                _createVNode("tr", null, [
                  _hoisted_17,
                  _createVNode("td", _hoisted_18, _toDisplayString(_ctx.selectedOrder.side == 1 ? 'BUY' : 'SELL'), 1)
                ]),
                _createVNode("tr", null, [
                  _hoisted_19,
                  (_ctx.selectedOrder.automaticExecution == true)
                    ? (_openBlock(), _createBlock("td", _hoisted_20, [
                        _hoisted_21
                      ]))
                    : (_openBlock(), _createBlock("td", _hoisted_22, [
                        _hoisted_23
                      ]))
                ]),
                _createVNode("tr", null, [
                  _hoisted_24,
                  (_ctx.selectedOrder.status == 0)
                    ? (_openBlock(), _createBlock("td", _hoisted_25, [
                        _hoisted_26
                      ]))
                    : (_ctx.selectedOrder.status == 1)
                      ? (_openBlock(), _createBlock("td", _hoisted_27, [
                          _hoisted_28,
                          _createVNode(_component_router_link, {
                            to: {
                    name: 'on-behalf-of.home.edit-manual.order',
                    params: {
                      customerId: _ctx.selectedOrder.customer.id,
                      orderId: _ctx.selectedOrder.id
                    }
                  }
                          }, {
                            default: _withId(() => [
                              _hoisted_29
                            ]),
                            _: 1
                          }, 8, ["to"])
                        ]))
                      : (_openBlock(), _createBlock("td", _hoisted_30, [
                          _hoisted_31,
                          _createVNode(_component_router_link, {
                            to: {
                    name: 'on-behalf-of.home.edit-manual.order',
                    params: {
                      customerId: _ctx.selectedOrder.customer.id,
                      orderId: _ctx.selectedOrder.id
                    }
                  }
                          }, {
                            default: _withId(() => [
                              _hoisted_32
                            ]),
                            _: 1
                          }, 8, ["to"])
                        ]))
                ]),
                _createVNode("tr", null, [
                  _hoisted_33,
                  _createVNode("td", _hoisted_34, _toDisplayString(_ctx.formatDate(_ctx.selectedOrder.createdAt, 'YYYY-MM-DD HH:mm:ss')), 1)
                ]),
                (_ctx.formatDate(_ctx.selectedOrder.lastModifiedAt))
                  ? (_openBlock(), _createBlock("tr", _hoisted_35, [
                      _hoisted_36,
                      _createVNode("td", _hoisted_37, _toDisplayString(_ctx.formatDate(
                    _ctx.selectedOrder.lastModifiedAt,
                    'YYYY-MM-DD HH:mm:ss'
                  )), 1)
                    ]))
                  : _createCommentVNode("", true),
                _createVNode("tr", null, [
                  _hoisted_38,
                  _createVNode("td", _hoisted_39, [
                    _createVNode(_component_icons_currency, {
                      cryptoCurrency: _ctx.selectedOrder.pair.baseCurrency.id,
                      width: '20',
                      height: '20',
                      key: _ctx.selectedOrder.pair.baseCurrency.id
                    }, null, 8, ["cryptoCurrency"]),
                    _hoisted_40,
                    _createVNode("code", _hoisted_41, _toDisplayString(_ctx.selectedOrder.pair.baseCurrency.currencyType === 1
                      ? '$ ' + _ctx.formatPrice(_ctx.selectedOrder.amount)
                      : _ctx.formatZeros(
                          _ctx.selectedOrder.amount,
                          _ctx.selectedOrder.pair.baseCurrency.exact
                        )), 1)
                  ])
                ]),
                _createVNode("tr", null, [
                  _hoisted_42,
                  _createVNode("td", _hoisted_43, [
                    _createVNode(_component_icons_currency, {
                      cryptoCurrency: _ctx.selectedOrder.pair.quoteCurrency.currencyType == 0 ? _ctx.selectedOrder.pair.quoteCurrency.id : null,
                      localCurrency: _ctx.selectedOrder.pair.quoteCurrency.currencyType != 0 ? _ctx.selectedOrder.pair.quoteCurrency.id : null,
                      width: '20',
                      height: '20',
                      key: _ctx.selectedOrder.pair.quoteCurrency.id
                    }, null, 8, ["cryptoCurrency", "localCurrency"]),
                    _hoisted_44,
                    _createVNode("code", _hoisted_45, _toDisplayString(_ctx.selectedOrder.pair.quoteCurrency.currencyType === 1
                      ? '$ ' + _ctx.formatPrice(_ctx.selectedOrder.unitPrice)
                      : _ctx.formatZeros(
                          _ctx.selectedOrder.unitPrice,
                          _ctx.selectedOrder.pair.quoteCurrency.exact
                        )), 1)
                  ])
                ]),
                _createVNode("tr", null, [
                  _hoisted_46,
                  _createVNode("td", _hoisted_47, [
                    _createVNode(_component_icons_currency, {
                      cryptoCurrency: _ctx.selectedOrder.pair.quoteCurrency.currencyType == 0 ? _ctx.selectedOrder.pair.quoteCurrency.id : null,
                      localCurrency: _ctx.selectedOrder.pair.quoteCurrency.currencyType != 0 ? _ctx.selectedOrder.pair.quoteCurrency.id : null,
                      width: '20',
                      height: '20',
                      key: _ctx.selectedOrder.pair.quoteCurrency.id
                    }, null, 8, ["cryptoCurrency", "localCurrency"]),
                    _hoisted_48,
                    _createVNode("code", _hoisted_49, _toDisplayString(_ctx.selectedOrder.pair.quoteCurrency.currencyType === 1
                      ? '$ ' + _ctx.formatPrice(_ctx.selectedOrder.finalPrice)
                      : _ctx.formatZeros(
                          _ctx.selectedOrder.finalPrice,
                          _ctx.selectedOrder.pair.quoteCurrency.exact
                        )), 1)
                  ])
                ]),
                _createVNode("tr", null, [
                  _hoisted_50,
                  _createVNode("td", _hoisted_51, [
                    _createVNode(_component_icons_currency, {
                      cryptoCurrency: _ctx.selectedOrder.pair.quoteCurrency.currencyType == 0 ? _ctx.selectedOrder.pair.quoteCurrency.id : null,
                      localCurrency: _ctx.selectedOrder.pair.quoteCurrency.currencyType != 0 ? _ctx.selectedOrder.pair.quoteCurrency.id : null,
                      width: '20',
                      height: '20',
                      key: _ctx.selectedOrder.pair.quoteCurrency.id
                    }, null, 8, ["cryptoCurrency", "localCurrency"]),
                    _hoisted_52,
                    _createVNode("code", _hoisted_53, _toDisplayString(_ctx.selectedOrder.pair.quoteCurrency.currencyType === 1
                      ? '$ ' + _ctx.formatPrice(_ctx.selectedOrder.totalCost)
                      : _ctx.formatZeros(
                          _ctx.selectedOrder.totalCost,
                          _ctx.selectedOrder.pair.quoteCurrency.exact
                        )), 1)
                  ])
                ]),
                _createVNode("tr", null, [
                  _hoisted_54,
                  _createVNode("td", _hoisted_55, [
                    _createVNode(_component_icons_currency, {
                      cryptoCurrency: _ctx.selectedOrder.pair.baseCurrency.id,
                      width: '20',
                      height: '20',
                      key: _ctx.selectedOrder.pair.baseCurrency.id
                    }, null, 8, ["cryptoCurrency"]),
                    _hoisted_56,
                    _createVNode("code", _hoisted_57, _toDisplayString(_ctx.selectedOrder.pair.baseCurrency.currencyType === 1
                      ? '$ ' + _ctx.formatPrice(_ctx.selectedOrder.baseCurrencyRevenue)
                      : _ctx.formatZeros(
                          _ctx.selectedOrder.baseCurrencyRevenue,
                          _ctx.selectedOrder.pair.baseCurrency.exact
                        )), 1)
                  ])
                ]),
                _createVNode("tr", null, [
                  _hoisted_58,
                  _createVNode("td", _hoisted_59, [
                    _createVNode(_component_icons_currency, {
                      cryptoCurrency: _ctx.selectedOrder.pair.quoteCurrency.currencyType == 0 ? _ctx.selectedOrder.pair.quoteCurrency.id : null,
                      localCurrency: _ctx.selectedOrder.pair.quoteCurrency.currencyType != 0 ? _ctx.selectedOrder.pair.quoteCurrency.id : null,
                      width: '20',
                      height: '20',
                      key: _ctx.selectedOrder.pair.quoteCurrency.id
                    }, null, 8, ["cryptoCurrency", "localCurrency"]),
                    _hoisted_60,
                    _createVNode("code", _hoisted_61, _toDisplayString(_ctx.selectedOrder.pair.quoteCurrency.currencyType === 1
                      ? '$ ' + _ctx.formatPrice(_ctx.selectedOrder.quoteCurrencyRevenue)
                      : _ctx.formatZeros(
                          _ctx.selectedOrder.quoteCurrencyRevenue,
                          _ctx.selectedOrder.pair.quoteCurrency.exact
                        )), 1)
                  ])
                ]),
                _hoisted_62
              ])
            ]),
            _createVNode("div", _hoisted_63, [
              _hoisted_64,
              _createVNode("table", _hoisted_65, [
                _createVNode("tr", null, [
                  _hoisted_66,
                  _createVNode("td", _hoisted_67, _toDisplayString(_ctx.selectedOrder.customer.id), 1)
                ]),
                _createVNode("tr", null, [
                  _hoisted_68,
                  _createVNode("td", _hoisted_69, _toDisplayString(_ctx.hideEmail(_ctx.selectedOrder.customer.email)), 1)
                ]),
                _createVNode("tr", null, [
                  _hoisted_70,
                  _createVNode("td", _hoisted_71, _toDisplayString(_ctx.selectedOrder.customer.firstName) + " " + _toDisplayString(_ctx.selectedOrder.customer.lastName), 1)
                ])
              ]),
              _hoisted_72,
              _createVNode("table", _hoisted_73, [
                _createVNode("tr", null, [
                  _hoisted_74,
                  _createVNode("td", _hoisted_75, [
                    _createTextVNode(_toDisplayString(_ctx.selectedOrder.pair.baseCurrency.id) + " " + _toDisplayString(_ctx.selectedOrder.pair.baseCurrency.description) + " ", 1),
                    _createVNode(_component_icons_currency, {
                      cryptoCurrency: _ctx.selectedOrder.pair.baseCurrency.id,
                      reverse: true,
                      width: '20',
                      height: '20',
                      key: _ctx.selectedOrder.pair.baseCurrency.id
                    }, null, 8, ["cryptoCurrency"])
                  ])
                ]),
                _createVNode("tr", null, [
                  _hoisted_76,
                  _createVNode("td", _hoisted_77, [
                    _createTextVNode(_toDisplayString(_ctx.selectedOrder.pair.quoteCurrency.id) + " " + _toDisplayString(_ctx.selectedOrder.pair.quoteCurrency.description) + " ", 1),
                    _createVNode(_component_icons_currency, {
                      cryptoCurrency: _ctx.selectedOrder.pair.quoteCurrency.currencyType == 0 ? _ctx.selectedOrder.pair.quoteCurrency.id : null,
                      localCurrency: _ctx.selectedOrder.pair.quoteCurrency.currencyType != 0 ? _ctx.selectedOrder.pair.quoteCurrency.id : null,
                      width: '20',
                      height: '20',
                      key: _ctx.selectedOrder.pair.quoteCurrency.id
                    }, null, 8, ["cryptoCurrency", "localCurrency"])
                  ])
                ])
              ])
            ])
          ]),
          _createVNode("div", _hoisted_78, [
            _createVNode("div", _hoisted_79, [
              _hoisted_80,
              _createVNode(_component_DataTable, {
                value: _ctx.selectedOrder.providerOrders,
                paginator: true,
                rows: 10,
                rowsPerPageOptions: [10, 20, 50],
                autoLayout: true,
                paginatorTemplate: "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
                currentPageReportTemplate: "Showing {first} to {last} of {totalRecords}"
              }, {
                empty: _withId(() => [
                  _hoisted_81
                ]),
                default: _withId(() => [
                  _createVNode(_component_Column, {
                    field: "provider.name",
                    header: "Provider",
                    bodyStyle: "text-align: left",
                    footer: "TOTAL"
                  }),
                  _createVNode(_component_Column, {
                    header: "Amount",
                    bodyStyle: "text-align: left"
                  }, {
                    body: _withId(({data}) => [
                      _createTextVNode(_toDisplayString(_ctx.selectedOrder.pair.baseCurrency.id) + " " + _toDisplayString(_ctx.selectedOrder.pair.baseCurrency.currencyType === 1
                    ? '$ ' + _ctx.formatPrice(data.amount)
                    : _ctx.formatZeros(
                        data.amount,
                        _ctx.selectedOrder.pair.baseCurrency.exact
                      )), 1)
                    ]),
                    footer: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.selectedOrder.pair.baseCurrency.id) + " " + _toDisplayString(_ctx.selectedOrder.pair.baseCurrency.currencyType === 1
                    ? '$ ' + _ctx.formatPrice(_ctx.selectedOrder.totalFilled)
                    : _ctx.formatZeros(
                        _ctx.selectedOrder.totalFilled,
                        _ctx.selectedOrder.pair.baseCurrency.exact
                      )), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    header: "Side",
                    bodyStyle: "text-align: left"
                  }, {
                    body: _withId(({data}) => [
                      (data.side == 1)
                        ? (_openBlock(), _createBlock("span", _hoisted_82, " BUY "))
                        : (_openBlock(), _createBlock("span", _hoisted_83, "SELL"))
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    header: "Unit Cost",
                    bodyStyle: "text-align: left"
                  }, {
                    body: _withId(({data}) => [
                      _createTextVNode(_toDisplayString(_ctx.selectedOrder.pair.quoteCurrency.id) + " " + _toDisplayString(_ctx.selectedOrder.pair.quoteCurrency.currencyType === 1
                    ? '$ ' + _ctx.formatPrice(data.unitCost)
                    : _ctx.formatZeros(
                        data.unitCost,
                        _ctx.selectedOrder.pair.quoteCurrency.exact
                      )), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    header: "Total Cost",
                    bodyStyle: "text-align: left",
                    footerStyle: "text-align: left"
                  }, {
                    body: _withId(({data}) => [
                      _createTextVNode(_toDisplayString(_ctx.selectedOrder.pair.quoteCurrency.id) + " " + _toDisplayString(_ctx.selectedOrder.pair.quoteCurrency.currencyType === 1
                    ? '$ ' + _ctx.formatPrice(data.totalCost)
                    : _ctx.formatZeros(
                        data.totalCost,
                        _ctx.selectedOrder.pair.quoteCurrency.exact
                      )), 1)
                    ]),
                    footer: _withId(() => [
                      _createTextVNode(_toDisplayString(_ctx.selectedOrder.pair.quoteCurrency.id) + " " + _toDisplayString(_ctx.selectedOrder.pair.quoteCurrency.currencyType === 1
                    ? '$ ' + _ctx.formatPrice(_ctx.selectedOrder.totalCost)
                    : _ctx.formatZeros(
                        _ctx.selectedOrder.totalCost,
                        _ctx.selectedOrder.pair.quoteCurrency.exact
                      )), 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    header: "Settlement Date",
                    bodyStyle: "text-align: left"
                  }, {
                    body: _withId(({data}) => [
                      _createTextVNode(_toDisplayString(_ctx.formatDate(data.settlementDatetime)), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
})